const BASE_ACTION_TYPE = 'LANDLORD::PROMOTION';

export const CREATE_PROMOTION = `${BASE_ACTION_TYPE}::CREATE_PROMOTION`;
export const EDIT_PROMOTION = `${BASE_ACTION_TYPE}::EDIT_PROMOTION`;
export const DELETE_PROMOTION = `${BASE_ACTION_TYPE}::DELETE_PROMOTION`;
export const FETCH_PROMOTION = `${BASE_ACTION_TYPE}::FETCH_PROMOTION`;
